import { assocPath, curryN, forEach, hasPath, last, path } from 'ramda';
import uuid from 'uuid-random';
import * as _ from 'underscore';

export const noop = () => {};

export const uniqueId = (prefix = '') => prefix + uuid();

let counter = 0;
// eslint-disable-next-line no-plusplus
export const uniqueSimpleId = (prefix = '') => prefix + counter++;

/**
 * Pick paths deep
 * @desc Select paths from object retaining initial structure
 * @param {Array<Array<string>>} paths
 * @param {Object} obj
 * @returns {Object}
 */
export const pickPathsDeep = curryN(2, (paths, obj) => {
    let result = {};

    forEach(
        (myPath) => {
            if (hasPath(myPath, obj)) {
                result = assocPath(myPath, path(myPath, obj), result);
            }
        },
        paths
    );

    return result;
});

/**
 * Pick paths flat
 * @desc Select paths from object into flat object with prop names defined by last prop name in each path. If these
 *  names coincide - the last one will take precedence.
 * @param {Array<Array<string>>} paths
 * @param {Object} obj
 * return {Object}
 */
export const pickPaths = curryN(2, (paths, obj) => {
    const result = {};

    forEach((myPath) => {
            const value = path(myPath, obj);
            const name = last(myPath);
            result[name] = value;
        },
        paths);

    return result;
});

export const areOmitedPropsEqual = (prevProps, nextProps, omitProps) => {
    const clearPrevProps = _.omit(prevProps, omitProps);
    const clearNextProps = _.omit(nextProps, omitProps);

    return _.isEqual(clearPrevProps, clearNextProps);
};
